export default "__VITE_ASSET__ClbXoNI8__"